import React from 'react';
import { UNAVAILABLE_IMAGE_URL } from '../../../constants/general';
/** Cancel Drawer Line Item Card */
export var CDLineItemCard = function (props) {
    var cancellationItem = props.cancellationItem, cancelAllItems = props.cancelAllItems;
    var imageUrl = cancellationItem.imageUrl, brandName = cancellationItem.brandName, description = cancellationItem.description, canceledQuantity = cancellationItem.canceledQuantity, maxCancelQuantity = cancellationItem.maxCancelQuantity, unitPrice = cancellationItem.unitPrice;
    var cancelQty = cancelAllItems ? maxCancelQuantity : canceledQuantity;
    var cancelAmount = cancelAllItems
        ? ((maxCancelQuantity !== null && maxCancelQuantity !== void 0 ? maxCancelQuantity : 0) * (unitPrice !== null && unitPrice !== void 0 ? unitPrice : 0)).toFixed(2)
        : ((canceledQuantity !== null && canceledQuantity !== void 0 ? canceledQuantity : 0) * (unitPrice !== null && unitPrice !== void 0 ? unitPrice : 0)).toFixed(2);
    return (React.createElement("div", { className: "cd-line-item-card sui-flex sui-flex-row sui-gap-3 sui-mb-6 sui-mt-6" },
        React.createElement("img", { className: "sui-self-start", alt: "Product", width: "50px", height: "50px", src: imageUrl || UNAVAILABLE_IMAGE_URL }),
        React.createElement("div", { className: "sui-flex sui-flex-col item-description-wrapper sui-gap-1" },
            React.createElement("span", null,
                React.createElement("span", { className: "sui-text-base sui-font-bold sui-inline-block sui-pr-1 item-name" }, brandName === null || brandName === void 0 ? void 0 : brandName.toUpperCase()),
                React.createElement("span", null, description)),
            React.createElement("span", null,
                "Cancel Qty: ",
                cancelQty),
            React.createElement("span", null,
                "Cancel Amount: $",
                cancelAmount))));
};
